import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import actionProps from 'actions';
import { PasswordReset } from 'resources';

import { Button, FormGroup } from 'react-bootstrap';

class ResetPasswordIndex extends React.Component {

  constructor() {
    super();

    this.state = {
      showPassword: false,
      validationError: null,
    };
  }

  onPasswordResetUseSuccess = ({ data }) => {
    const { loginWithToken, notify } = this.props.actions;

    this.setState({
      submitting: false,
    });

    loginWithToken(data);
    notify({
      message: 'Your password has been updated',
    });
  }

  onPasswordResetUseFailure = ({ data }) => {
    const { password, code } = data.password_reset;

    this.setState({
      validationError: password || code,
      submitting: false,
    });

    this.focusInput();
  }

  doPasswordResetUse = (e) => {
    e.preventDefault();

    const password = e.target.elements['password_reset.password'].value;
    const { code } = this.props.params;

    this.setState({
      submitting: true,
    });

    PasswordReset.use({
      data: {
        password_reset: {
          password,
          code,
        },
      },
      onSuccess: this.onPasswordResetUseSuccess,
      onFailure: this.onPasswordResetUseFailure,
    });
  }

  doResetErrorState = () => {
    this.setState({
      validationError: null,
    });
  }

  doToggleShowPassword = e => {
    e.preventDefault();

    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  refInput = input => (this.input = input);

  focusInput() {
    /* eslint-disable react/no-find-dom-node */
    ReactDOM.findDOMNode(this.input).focus();
  }

  render() {
    const { showPassword, validationError } = this.state;

    return (
      <div className="account-wrapper">

        <h3 className="m-b-0">Reset your password</h3>

        <form className="form account-form account-body"
          onSubmit={this.doPasswordResetUse}
          onInput={this.doResetErrorState}
        >

          <FormGroup className="forgot-password"
            validationState={_.isNull(validationError) ? null : 'error'}
          >
            <a onClick={this.doToggleShowPassword}>{showPassword ? 'hide' : 'show'}</a>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password_reset.password"
              className="form-control"
              placeholder="Your new password"
              ref={this.refInput}
              tabIndex={1}
              autoFocus
            />
            {_.isNull(validationError) ? null : <span className="help-block">{validationError}</span>}
          </FormGroup>

          <FormGroup>
            <Button type="submit"
              bsStyle="secondary"
              bsSize="lg"
              block
              tabIndex={5}
              disabled={this.state.submitting}
            >Update password</Button>
          </FormGroup>

        </form>

      </div>
    );
  }

}

export default connect(null, actionProps)(ResetPasswordIndex);
